import * as React from "react";
import { Icon } from "sb-resp-ui";
import { GameState } from "../GameState";
export const GameStateWrapper = (props) => props.details.isDesktop
    ? renderGameStateDesktop(props.details, props.componentPrefix)
    : renderGameStateMobile(props.details, props.componentPrefix);
const renderGameStateDesktop = (details, componentPrefix) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`, "data-uat": `div-ev-list-${componentPrefix}-clock` },
    React.createElement(Icon, { i: `i-o-sport i-o-sport-${details.event.sportId}` }),
    !details.hideGameState &&
        React.createElement(GameState, { details: details, componentPrefix: componentPrefix }));
const renderGameStateMobile = (details, componentPrefix) => {
    return !details.hideGameState && !details.event.isInKickOffState
        ? React.createElement(GameState, { details: details, componentPrefix: componentPrefix })
        : React.createElement(React.Fragment, null);
};
//# sourceMappingURL=GameStateWrapper.js.map